import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from "@sentry/react"
import './index.css'
import App from './app/App.tsx'

// Initialize environment configuration FIRST, before importing shared services
import { initializeEnvironment } from './config/environment'
console.log('🚀 ENVIRONMENT SEPARATION: Database connection logic updated')
console.log('🌍 TIMESTAMP: 2025-11-10T00:15:00Z - Testing with correct VERCEL_PROJECT_ID secret')
initializeEnvironment()

// Now import authService AFTER environment is configured
import { authService } from '@joinomu/shared'

// Expose authService globally for testing BMI eligibility
// @ts-ignore
window.authService = authService
console.log('🧪 DEBUG: authService available as window.authService')

// Initialize Sentry error monitoring for staging and production
if (import.meta.env.VITE_ENVIRONMENT !== 'local') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENVIRONMENT,
    tracesSampleRate: 1.0,
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)